<!--
  Three wrappers, always rendered. The header and the actions row hide
  themselves through `:empty` in the stylesheet rather than through an
  `@if` on a content query: a `contentChild` would need the caller to put a
  directive on their own markup, and `:empty` needs nothing at all.
-->
<div class="bz-card__header"><ng-content select="[bzCardHeader]" /></div>

<div class="bz-card__body"><ng-content /></div>

<div class="bz-card__actions"><ng-content select="[bzCardActions]" /></div>
